import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ContractualDataModel} from '../../../../models/ContractualDataModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractualValuesService} from '../service-contractual-values/contractual-values.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogDetailComponent} from '../../../general-components/dialog-detail/dialog-detail.component';
import {DialogSubmitComponent} from '../../../general-components/dialog-submit/dialog-submit.component';
import {ChargingMethodologyService} from '../../../general-services/service-charging-methodology/charging-methodology.service';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {RegionModel} from '../../../../models/RegionModel';

@Component({
  selector: 'app-new-contractual-values-massive',
  templateUrl: './new-contractual-values-massive.component.html',
  styleUrls: ['./new-contractual-values-massive.component.scss']
})
export class NewContractualValuesMassiveComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  dataSource: ContractualDataModel;
  showActions: boolean;
  contractualData: ContractualDataModel;
  providerSelect: ProviderModel;
  localCustomerSelect: LocalCustomerModel;
  contractTypeSelect: ContractTypeModel;
  resourceUnitSelect: ResourcesUnitModel;
  sizeSelect: SizeModel;
  siteSelect: SiteModel;
  regionSelect: RegionModel;
  allMonth: any;
  allCharging: any;
  listData: MatTableDataSource<any>;
  numAnnoMeseFrom: number;

  showLC: boolean;
  showType: boolean;
  showResourceUnit: boolean;
  showProvider: boolean;
  showSize: boolean;
  showSite: boolean;
  showRegion: boolean;
  resetPriceRange: boolean;
  enablePriceRange: boolean;
  enableArcRrc: boolean;
  enablePXQ: boolean;
  enableFixed: boolean;

  registerForm: FormGroup;
  submitted = false;
  getFirstYearSubscribe: Subscription;
  saveContractualData: Subscription;
  getPageSubscribe: Subscription;
  getAllChargingMethodologySubscribe: Subscription;


  constructor(private route: ActivatedRoute, private router: Router,
              private contractualDataService: ContractualValuesService,
              private formBuilder: FormBuilder,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService,
              private chargingMethodologyService: ChargingMethodologyService) {
    super();
    this.showActions = false;
    this.showLC = false;
    this.resetPriceRange = false;

    this.contractualData = new ContractualDataModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.regionSelect = new RegionModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.siteSelect = new SiteModel();
    this.sizeSelect = new SizeModel();

    this.providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.contractualData.provider = this.providerSelect;


    this.hideAllTable();
    this.getAllMonth();
    this.getAllChargingMethodology();
    this.getFirstYear();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      annoMeseFrom: [{value: '', disabled: false}, Validators.required],
      annoMeseTo: [{value: '', disabled: false}, Validators.required],
      provider: [{value: this.providerSelect.cod, disabled: false}, Validators.required],
      localCustomer: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      chargingMethodology: [{value: '', disabled: false}, Validators.required],
      compensationPayment: [{value: '', disabled: false}],
      terminationFee: [{value: '', disabled: false}],
      bmc: [{value: '', disabled: false}, Validators.required],
      bmv: [{value: '', disabled: false}, Validators.required],
      arc: [{value: '', disabled: false}, Validators.required],
      arc2: [{value: '', disabled: false}],
      rrc: [{value: '', disabled: false}, Validators.required],
      rrc2: [{value: '', disabled: false}],
      sizeCod: [{value: '', disabled: false}],
      siteCod: [{value: '', disabled: false}],
      region: [{value: '', disabled: false}, Validators.required],
      pxq: [{value: '', disabled: false}, Validators.required],
      bandwidth1: [{value: '', disabled: false}],
      bandwidth2: [{value: '', disabled: false}]
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    this.handleCharging(this.contractualData.chargingMethodology);
    if (this.registerForm.valid && this.checkRangeListValid()) {
      event.preventDefault();
      this.updateFieldValues();
      this.loaderService.display(true);
      // this.contractualData.currency = new CurrencyModel(1,'EUR', 'EUR');
      this.saveContractualData = this.contractualDataService.saveMassive(this.contractualDataService.baseUrl, this.contractualData)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              this.loaderService.display(false);
            } else {
              this.loaderService.display(false);
              this.apriDialog(result);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
            }
          },
          error => {
            toastr.error('Contractual Value Massive was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  updateFieldValues() {
    this.contractualData.numAnnoMese = null;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = this.registerForm.value.arc;
    this.contractualData.arc2 = this.registerForm.value.arc2;
    this.contractualData.rrc = this.registerForm.value.rrc;
    this.contractualData.rrc2 = this.registerForm.value.rrc2;
    this.contractualData.pxq = this.registerForm.value.pxq;
    this.contractualData.bandwidth1 = this.registerForm.value.bandwidth1;
    this.contractualData.bandwidth2 = this.registerForm.value.bandwidth2;
    this.contractualData.compensationPayment = this.registerForm.value.compensationPayment ? this.registerForm.value.compensationPayment : 0;
    this.contractualData.terminationFee = this.registerForm.value.terminationFee ? this.registerForm.value.terminationFee : 0;
  }

  openDialog() {
    const contractualData = this.dataSource;
    const list: GenericArray[] = [];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth(this.providerSelect)
      .subscribe(
        (result: any) => {
          this.allMonth = result;
        });
  }

  getAllChargingMethodology() {
    this.getAllChargingMethodologySubscribe = this.chargingMethodologyService.getAll(this.chargingMethodologyService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.allCharging = result;
        }
      );
  }

  getFirstYear() {
    this.loaderService.display(true);
    this.getFirstYearSubscribe = this.annoMeseService.getFirtsAnnoMese()
      .subscribe(
        (result: any) => {
          this.numAnnoMeseFrom = result;
          this.loaderService.display(false);
        });
  }

  ngOnDestroy(): void {
    if (this.saveContractualData) {
      this.saveContractualData.unsubscribe();
    }
  }

  getElementSelectedProvider($event: ProviderModel) {
    this.contractualData.provider = $event;
    this.providerSelect = $event;
    this.registerForm.patchValue({
      provider: this.providerSelect ? this.providerSelect.cod : undefined
    });
  }

  getElementSelectedRegion($event: RegionModel) {
    this.contractualData.region = $event;
    this.regionSelect = $event;
    this.registerForm.patchValue({
      region: this.regionSelect ? this.regionSelect.cod : undefined
    });
  }

  getElementSelectedContractType($event: ContractTypeModel) {
    this.contractualData.contractType = $event;
    this.contractTypeSelect = $event;
    this.registerForm.patchValue({
      contractType: this.contractTypeSelect ? this.contractTypeSelect.cod : undefined
    });
  }

  getElementSelectedLC($event: LocalCustomerModel) {
    this.contractualData.localCustomer = $event;
    this.localCustomerSelect = $event;
    this.registerForm.patchValue({
      localCustomer: this.localCustomerSelect ? this.localCustomerSelect.cod : undefined
    });
  }

  getElementSelectedResourceUnit($event: ResourcesUnitModel) {
    this.contractualData.resourceUnit = $event;
    this.resourceUnitSelect = $event;
    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect ? this.resourceUnitSelect.cod : undefined
    });
  }

  getElementSelectRangeList($event) {
    this.contractualData.priceRangeList = $event.priceList;
  }

  getElementSelectedSize($event: any) {
    this.contractualData.size = $event.row;
    this.sizeSelect = $event.row;
    this.registerForm.patchValue({
      sizeCod: this.sizeSelect.cod
    });
  }

  getElementSelectedSite($event: any) {
    this.contractualData.site = $event.row;
    this.siteSelect = $event.row;
    this.registerForm.patchValue({
      siteCod: this.siteSelect.cod
    });
  }

  toggleSize() {
    this.showSize = !this.showSize;
  }

  toggleSite() {
    this.showSite = !this.showSite;
  }

  handleNumAnnoMeseFrom(value) {
    this.contractualData.numAnnoMeseFrom = value;
  }

  handleNumAnnoMeseTo(value) {
    this.contractualData.numAnnoMeseTo = value;
  }

  handleCharging(chargingMethSelected: string) {
    this.contractualData.chargingMethodology = chargingMethSelected;
    this.enablePriceRange = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PRICE_RANGE;
    this.enablePXQ = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PXQ;
    this.enableArcRrc = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.ARC_RRC;
    this.enableFixed = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.FIXED;
    this.contractualData.compensationPayment = this.registerForm.value.compensationPayment;
    this.contractualData.terminationFee = this.registerForm.value.terminationFee;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = 0;
    this.contractualData.arc2 = 0;
    this.contractualData.rrc = 0;
    this.contractualData.rrc2 = 0;
    this.contractualData.bandwidth1 = this.registerForm.value.bandwidth1;
    this.contractualData.bandwidth2 = this.registerForm.value.bandwidth2;

    if (this.enablePriceRange) {
      this.contractualData.bmc = 0;
      this.contractualData.bmv = 0;
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({bmc: this.contractualData.bmc});
      this.registerForm.patchValue({bmv: this.contractualData.bmv});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enablePXQ) {
      this.contractualData.pxq = this.registerForm.value.pxq;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }

    if (this.enableArcRrc) {
      this.contractualData.pxq = 0;
      this.contractualData.arc = this.registerForm.value.arc;
      this.contractualData.rrc = this.registerForm.value.rrc;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enableFixed) {
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  hideAllTable() {
    this.showProvider = false;
    this.showLC = false;
    this.showResourceUnit = false;
    this.showType = false;
    this.showSite = false;
    this.showSize = false;
    this.showRegion = false;
  }

  reset() {
    this.resetPriceRange = !this.resetPriceRange;
    this.resetProvider();
    this.resetLc();
    this.resetResourceUnitCod();
    this.resetContractType();
    this.resetRegion();
    this.resetSite();
    this.resetSize();
    this.hideAllTable();
  }

  resetLc() {
    this.registerForm.patchValue({
      localCustomer: ''
    });
    this.localCustomerSelect = new LocalCustomerModel();
  }

  resetContractType() {
    this.registerForm.patchValue({
      contractType: ''
    });
    this.contractTypeSelect = new ContractTypeModel();
  }

  resetResourceUnitCod() {
    this.registerForm.patchValue({
      resourceUnit: ''
    });
    this.resourceUnitSelect = new ResourcesUnitModel();
  }

  resetProvider() {
    this.registerForm.patchValue({
      provider: ''
    });
    this.providerSelect = new ProviderModel();
  }

  resetSize() {
    this.registerForm.patchValue({
      sizeCod: ''
    });
    this.sizeSelect = new SizeModel();
  }

  resetSite() {
    this.registerForm.patchValue({
      siteCod: ''
    });
    this.siteSelect = new SiteModel();
  }

  resetRegion() {
    this.registerForm.patchValue({
      region: ''
    });
    this.regionSelect = new RegionModel();
  }

  apriDialog(result: any) {
    const dialogRef = this.dialog.open(DialogSubmitComponent, {
      data: {result}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  checkRangeListValid() {
    let returnValue = false;
    if (this.enablePriceRange) {
      if (this.contractualData.priceRangeList.length > 0) {
        const lastIndexPriceRange = this.contractualData.priceRangeList.length - 1;
        if (this.contractualData.priceRangeList[lastIndexPriceRange].volMax === null) {
          returnValue = true;
        } else {
          toastr.warning('Compile last element range to continue', 'Warning');
          returnValue = false;
        }
      }
    } else {
      returnValue = true;
    }

    return returnValue;
  }

}
